import { PHONE_DIGITS_PATTERN } from 'src/constants/contactValidationPatterns';

export const normalizePhoneNumber = (phone: string) => {
  let normalized = phone.replace(/[\s\-()]/g, '').replace('+1', '').replace('+', '');

  if (normalized.length === 11 && normalized.startsWith('1')) {
    normalized = normalized.substring(1);
  }

  return normalized;
};

export const cleanPhoneInput = (phone: string): string => {
  return phone.replace(/^Add:?\s*/, '').trim();
};

export const isValidPhoneNumber = (phone: string | undefined): boolean => {
  if (!phone) {
    return false;
  }

  const trimmedPhone = cleanPhoneInput(phone);
  if (!trimmedPhone) {
    return false;
  }

  const normalizedPhone = normalizePhoneNumber(trimmedPhone);
  return PHONE_DIGITS_PATTERN.test(normalizedPhone);
};
